"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundToggleChipGroupField = BoundToggleChipGroupField;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const inputs_1 = require("../inputs");
const utils_1 = require("../utils");
const defaultLabel_1 = require("../utils/defaultLabel");
/** Wraps `ToggleChipGroup` and binds it to a form field. */
function BoundToggleChipGroupField(props) {
    const { field, onChange = (value) => field.set(value), label = (0, defaultLabel_1.defaultLabel)(field.key), ...others } = props;
    const testId = (0, utils_1.useTestIds)(props, field.key);
    return ((0, jsx_runtime_1.jsx)(mobx_react_1.Observer, { children: () => (0, jsx_runtime_1.jsx)(inputs_1.ToggleChipGroup, { label: label, values: field.value || [], onChange: onChange, ...testId, ...others }) }));
}
